import React from "react";

import currencyCodes, {CurrencyCodeRecord} from "currency-codes";
import SingleSelectField from "./SingleSelectField";


interface CurrencySelectFieldProps {
    value: string | undefined;
    onChange: (currencyCode?: string) => void;
    errorMessage?: string;
    required?: boolean;
    label?: string;
}

export function CurrencySelectField(props: Readonly<CurrencySelectFieldProps>) {
    const {value, onChange, errorMessage, required, label} = props;

    function findCurrencyByCode(code: string | undefined): CurrencyCodeRecord | undefined {
        return currencyCodes.data.find(c => c.code === code);
    }

    function formatCurrency(code: string | undefined | null) {
        if (code) {
            const currency = findCurrencyByCode(code);
            if (currency) {
                return currency.code + ' - ' + currency.currency;
            }
        }
        return null;
    }

    return (
            <SingleSelectField
                    id="currency"
                    label={label ?? ""}
                    options={currencyCodes.data.map(c => c.code)}
                    getOptionLabel={code => formatCurrency(code) ?? ""}
                    value={value}
                    onChange={code => onChange(code ?? undefined)}
                    required={required}
                    errorMessage={errorMessage} />
    );
}
